module.exports = __WEBPACK_EXTERNAL_MODULE_86__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 86
// module chunks = 0